import Grid from '@mui/material/Grid';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import { useSequentialVideos } from '../../hooks/useSequentialVideos/useSequentialVideos';
import { MediaItem } from '../MediaItem/MediaItem';

const GAP_SIZE = 16;
const HERO_MEDIA_MAX_HEIGHT = `${500 + GAP_SIZE}px`;
const REMAINING_MEDIA_MAX_HEIGHT = `${250}px`;

export const HeroMediaGrid = ({
  photoEvidence,
  alt,
  placeholderSrc,
}: {
  photoEvidence: string[];
  alt?: string;
  placeholderSrc?: string;
}) => {
  const allMedia = photoEvidence.slice(0, 5);
  const heroMedia = allMedia[0];
  const remainingMedia = allMedia.slice(1);

  const { videoRefs, handleVideoEnd } = useSequentialVideos(allMedia);

  return (
    <Grid container spacing={2}>
      <Grid sx={{ height: HERO_MEDIA_MAX_HEIGHT }} size={6}>
        <MediaItem
          media={heroMedia}
          alt={alt}
          slotProps={{
            image: {
              placeholderSrc,
              sx: {
                aspectRatio: '1 / 1',
                height: HERO_MEDIA_MAX_HEIGHT,
              },
              zoomOnHover: true,
            },
            loader: {
              height: HERO_MEDIA_MAX_HEIGHT,
            },
            video: {
              controls: true,
              loop: false,
              muted: true,
              onEnded: handleVideoEnd,
              playsInline: true,
              ref: (el: HTMLVideoElement) => {
                // eslint-disable-next-line react-hooks/immutability
                videoRefs.current[0] = el;
              },
              sx: {
                aspectRatio: '1 / 1',
                maxHeight: HERO_MEDIA_MAX_HEIGHT,
              },
            },
          }}
        />
      </Grid>
      <Grid sx={{ height: REMAINING_MEDIA_MAX_HEIGHT }} size={6}>
        <ImageList cols={2} gap={GAP_SIZE} sx={{ margin: 0 }}>
          {remainingMedia.map((media, index) => (
            <ImageListItem key={media}>
              <MediaItem
                media={media}
                alt={alt}
                slotProps={{
                  image: {
                    placeholderSrc,
                    rounded: false,
                    sx: {
                      aspectRatio: '1 / 1',
                      maxHeight: REMAINING_MEDIA_MAX_HEIGHT,
                    },
                    zoomOnHover: true,
                  },
                  loader: {
                    height: REMAINING_MEDIA_MAX_HEIGHT,
                  },
                  video: {
                    loop: false,
                    muted: true,
                    onEnded: handleVideoEnd,
                    ref: (el: HTMLVideoElement) => {
                      videoRefs.current[index + 1] = el;
                    },
                    sx: {
                      aspectRatio: '1 / 1',
                      height: '100%',
                      maxHeight: REMAINING_MEDIA_MAX_HEIGHT,
                    },
                  },
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Grid>
    </Grid>
  );
};
